import React from 'react';
import {
  ArrowDownward as LowIcon,
  PriorityHigh as HighIcon,
  Remove as MediumIcon,
} from '@mui/icons-material';
import { Chip } from '@mui/material';

interface PriorityBadgeProps {
  priority: 'High' | 'Medium' | 'Low';
  size?: 'small' | 'medium';
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority, size = 'small' }) => {
  const config = {
    High: {
      color: '#d32f2f' as const,
      bgColor: '#ffebee' as const,
      icon: <HighIcon sx={{ fontSize: 16 }} />,
    },
    Medium: {
      color: '#f57c00' as const,
      bgColor: '#fff3e0' as const,
      icon: <MediumIcon sx={{ fontSize: 16 }} />,
    },
    Low: {
      color: '#f9a825' as const,
      bgColor: '#fffde7' as const,
      icon: <LowIcon sx={{ fontSize: 16 }} />,
    },
  };

  const { color, bgColor, icon } = config[priority];

  return (
    <Chip
      icon={icon}
      label={priority}
      size={size}
      sx={{
        bgcolor: bgColor,
        color: color,
        fontWeight: 600,
        fontSize: size === 'small' ? '0.75rem' : '0.875rem',
        '& .MuiChip-icon': {
          color: color,
        },
      }}
    />
  );
};
